import React from "react";
import "../css/welcomeWidgets.css";

// Editable list of upcoming holidays. Festival dates are approximate —
// update these each year as needed.
const HOLIDAYS = [
  { name: "Independence Day", date: "2026-08-15", emoji: "🇮🇳" },
  { name: "Raksha Bandhan", date: "2026-08-28", emoji: "🪢" },
  { name: "Ganesh Chaturthi", date: "2026-09-14", emoji: "🛕" },
  { name: "Gandhi Jayanti", date: "2026-10-02", emoji: "🕊️" },
  { name: "Dussehra", date: "2026-10-20", emoji: "🏹" },
  { name: "Diwali", date: "2026-11-08", emoji: "🪔" },
  { name: "Christmas", date: "2026-12-25", emoji: "🎄" },
  { name: "New Year's Day", date: "2027-01-01", emoji: "🎉" },
  { name: "Republic Day", date: "2027-01-26", emoji: "🇮🇳" },
];

const HolidaysBanner = () => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const upcoming = HOLIDAYS.map((h) => {
    const d = new Date(h.date + "T00:00:00");
    const days = Math.round((d - today) / 86400000);
    return { ...h, d, days };
  })
    .filter((h) => h.days >= 0)
    .sort((a, b) => a.d - b.d);

  if (!upcoming.length) return null;

  return (
    <div className="ww-holidays">
      <span className="ww-holidays-tag">UPCOMING HOLIDAYS</span>
      <div className="ww-marquee">
        <div className="ww-marquee-track">
          {[...upcoming, ...upcoming].map((h, i) => (
            <span className="ww-holiday-item" key={i}>
              <span className="ww-holiday-emoji">{h.emoji}</span>
              <b>{h.name}</b>
              <span className="ww-holiday-date">
                {h.d.toLocaleDateString("en-IN", {
                  day: "numeric",
                  month: "short",
                })}
              </span>
              <span className="ww-holiday-days">
                {h.days === 0
                  ? "Today"
                  : `in ${h.days} day${h.days > 1 ? "s" : ""}`}
              </span>
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HolidaysBanner;
